import styled from '@emotion/styled'

export const ContactBalanceDateSelectorWrapper = styled.div`
  margin-left: auto;
`
